import { Typography } from 'antd';
import AppSearchInput from 'components/AppSearchInput';
import { useModalState } from 'hooks/useModalState';
import { noop } from 'lodash';
import React, { useState } from 'react';
import { McInputProps } from './Marketing';
import MarketingModal from './MarketingModal';
import MarketingSearchModal from './MarketingSearchModal';
export type MarketingValueType = {
  mcid?: number;
  mclabel?: string;
};
export type MarketingInputProps = {
  onChange?: McInputProps['onSelect'];
  value?: MarketingValueType | any;
  clear?: boolean;
  onlymcid?: boolean;
  display?: boolean;
  onClear?: () => void;
  mcstatus?: string;
  isCreate?: boolean;
  style?: any;
};

const MarketingInput = ({
  onChange = noop,
  value,
  onlymcid,
  style,
  display,
  isCreate,
  onClear
}: MarketingInputProps) => {
  const [Params, setParams] = useState<any>({
    mcid: value?.mcid,
    mclabel: value?.mclabel
  });
  const { visible, close, open } = useModalState(false);
  // eslint-disable-next-line no-unused-vars
  const [mCModal, setMcModal] = useState(false);

  const handleSelect = (item: any) => {
    onlymcid ? onChange(item.mcid) : onChange(item);
    setParams({
      mcid: item?.mcid,
      mclabel: item?.mclabel
    });
    close();
  };

  const [visibleModal, setvisibleModal] = useState(false);

  return (
    <>
      <div style={style}>
        {display ? (
          <Typography.Link
            onClick={() => {
              setMcModal(true);
              setvisibleModal(true);
            }}
            title="Open details"
            ellipsis
          >
            {onlymcid && !value?.mcid
              ? Params?.mcid
                ? `${Params.mclabel ?? ''} `
                : isCreate
                ? 'Create a Marketing Campaign....'
                : 'Select a Marketing Campaign'
              : value?.mcid
              ? `${value.mclabel ?? ''} `
              : isCreate
              ? 'Create a Marketing Campaign....'
              : Params?.mcid
              ? `${Params.mclabel ?? ''} `
              : 'Select a Marketing Campaign'}
          </Typography.Link>
        ) : (
          <AppSearchInput
            onSearch={open}
            onClear={() => {
              value = {
                mcid: undefined,
                mclabel: undefined
              };
              setParams({ mcid: undefined, mclabel: undefined });
              onClear && onClear();
            }}
            isNotEmpty={Params?.mcid || value?.mcid}
            value={
              <Typography.Link
                onClick={() => {
                  setMcModal(true);
                  setvisibleModal(true);
                }}
                title="Open details"
                ellipsis
              >
                {onlymcid && value?.mcid
                  ? Params?.mcid && value !== 0 && value !== ''
                    ? `${Params.mclabel ?? ''} `
                    : isCreate
                    ? 'Create a Marketing Campaign....'
                    : 'Select a Marketing Campaign'
                  : value?.mcid && value !== 0
                  ? `${value.mclabel ?? ''} `
                  : isCreate
                  ? 'Create a Marketing Campaign....'
                  : Params?.mcid && value !== 0
                  ? `${Params.mclabel ?? ''} `
                  : 'Select a Marketing Campaign'}
              </Typography.Link>
            }
          />
        )}
      </div>

      <MarketingSearchModal
        initialSearchParams={{ mcstatus: 'ACTIVE' }}
        visible={visible}
        onCancel={close}
        onSelect={handleSelect}
      />
      <MarketingModal
        onCancel={() => {
          setvisibleModal(false);
        }}
        onSuccess={() => setvisibleModal(true)}
        visible={visibleModal}
        onSelect={handleSelect}
        mcid={value?.mcid ?? 0}
      />
    </>
  );
};

export default MarketingInput;
